import { useState } from 'react'
import { Key } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { getPasswordRequirementStatus } from '@/utils/passwordRequirements'
import { cn } from '@/utils/cn'

type Props = {
  saving: boolean
  onSubmit: (input: {
    currentPassword: string
    newPassword: string
    confirmPassword: string
  }) => Promise<boolean>
}

export function ProfilePasswordFields({ saving, onSubmit }: Props) {
  const [open, setOpen] = useState(false)
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const requirements = getPasswordRequirementStatus(newPassword)

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault()
    const ok = await onSubmit({ currentPassword, newPassword, confirmPassword })
    if (!ok) return
    setCurrentPassword('')
    setNewPassword('')
    setConfirmPassword('')
    setOpen(false)
  }

  if (!open) {
    return (
      <Button type='button' variant='secondary' size='sm' icon={<Key size={13} />} onClick={() => setOpen(true)}>
        Alterar Senha
      </Button>
    )
  }

  return (
    <form onSubmit={handleSubmit} className={cn('space-y-3 max-w-sm')}>
      <label className='block text-[12px] text-[var(--text-muted)]'>
        Senha atual
        <input
          type='password'
          autoComplete='current-password'
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          className='mt-1 w-full bg-[var(--glass-bg)] border border-[var(--glass-border)] rounded-md px-3 py-2 text-[13px] min-h-[44px]'
        />
      </label>
      <label className='block text-[12px] text-[var(--text-muted)]'>
        Nova senha
        <input
          type='password'
          autoComplete='new-password'
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className='mt-1 w-full bg-[var(--glass-bg)] border border-[var(--glass-border)] rounded-md px-3 py-2 text-[13px] min-h-[44px]'
        />
      </label>
      <label className='block text-[12px] text-[var(--text-muted)]'>
        Confirmar nova senha
        <input
          type='password'
          autoComplete='new-password'
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className='mt-1 w-full bg-[var(--glass-bg)] border border-[var(--glass-border)] rounded-md px-3 py-2 text-[13px] min-h-[44px]'
        />
      </label>
      <ul className='space-y-1 text-[11px] text-[var(--text-muted)]'>
        {requirements.map((item) => (
          <li key={item.id} className={item.met ? 'text-emerald-500' : undefined}>
            {item.met ? '✓' : '○'} {item.label}
          </li>
        ))}
      </ul>
      <div className='flex gap-2'>
        <Button type='submit' size='sm' loading={saving}>
          Salvar senha
        </Button>
        <Button type='button' variant='ghost' size='sm' onClick={() => setOpen(false)}>
          Cancelar
        </Button>
      </div>
    </form>
  )
}
